import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { Empty_Person_Amozesh_Interface, Person_Amozesh_Interface } from 'src/app/Interface/Person_Amozesh_Interface';
import { Empty_Person_Document_Interface, Person_Document_Interface } from 'src/app/Interface/Person_Document_Interface';
import { Empty_Person_Interface, Person_Interface } from 'src/app/Interface/Person_Interface';
import { Empty_Person_Kari_Interface, Person_Kari_Interface } from 'src/app/Interface/Person_Kari_Interface';
import { Empty_Person_Skill_Interface, Person_Skill_Interface } from 'src/app/Interface/Person_Skill_Interface';
import { Empty_Person_Tahghigh_Interface, Person_Tahghigh_Interface } from 'src/app/Interface/Person_Tahghigh_Interface';
import { Empty_Person_Tahsili_Interface, Person_Tahsili_Interface } from 'src/app/Interface/Person_Tahsili_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { DocumentGroupService } from 'src/app/Service/DocumentGroup/DocumentGroup.service';
import { DocumentTitleService } from 'src/app/Service/DocumentTitle/DocumentTitle.service';
import { DorehAmoozeshiService } from 'src/app/Service/DorehAmoozeshi/DorehAmoozeshi.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { PersonService } from 'src/app/Service/Person/Person.service';
import { ProvinceService } from 'src/app/Service/Province/Province.service';
import { SarFaslAmozeshiService } from 'src/app/Service/SarFaslAmozeshi/SarFaslAmozeshi.service';
import { SematService } from 'src/app/Service/Semat/Semat.service';
import { SkillService } from 'src/app/Service/Skill/Skill.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-PersonEdit1',
  templateUrl: './PersonEdit1.component.html',
  styleUrls: ['./PersonEdit1.component.scss']
})
export class PersonEdit1Component implements OnInit {
  BaseUrl = environment.BaseUrl
  EditRecord: number = 0

  constructor(
    private Person_Service: PersonService,
    private Nav_Service: NavService,
    private province_Service: ProvinceService,
    private Alertify_Service: AlertifyService,
    private Semat_Service: SematService,
    private modalService: BsModalService,
    private route: ActivatedRoute,


    private DocumentTitle_Service: DocumentTitleService,
    private DocumentGroup_Service: DocumentGroupService,
    private SarFaslAmozeshi_Service: SarFaslAmozeshiService,
    private DorehAmoozeshi_Service: DorehAmoozeshiService,
    private Skill_Service: SkillService
  ) { }

  ngOnInit() {

    this.Form_List_Hasilat_Record = new FormGroup({

      id: new FormControl(),
      date_starrt: new FormControl(null, Validators.required),
      date_end: new FormControl(null, Validators.required),
      degree: new FormControl(null, Validators.required),
      reshteh: new FormControl(null, Validators.required),
      grayesh: new FormControl(null, Validators.required),
      uni: new FormControl(null, Validators.required),
      moadel: new FormControl(null, Validators.required),
    })

    this.Form_List_kari_Record = new FormGroup({

      id: new FormControl(),
      date_starrt: new FormControl(null, Validators.required),
      date_end: new FormControl(null, Validators.required),
      companyName: new FormControl(null, Validators.required),
      type: new FormControl(null, Validators.required),
      semat: new FormControl(null, Validators.required),
      leave: new FormControl(null, Validators.required),
      tel: new FormControl(null, Validators.required),
      address: new FormControl(null, Validators.required),
    })

    this.Form_List_Amoozeshi_Record = new FormGroup({

      id: new FormControl(),
      date_starrt: new FormControl(null, Validators.required),
      date_end: new FormControl(null, Validators.required),
      sarFaslAmozeshi_id: new FormControl("0", Validators.required),
      dorehAmoozeshi_id: new FormControl("0", Validators.required),
      modat: new FormControl(null, Validators.required),
      bargozarKonnadeh: new FormControl(null, Validators.required),
    })

    this.Form_List_Skill_Record = new FormGroup({

      id: new FormControl(),
      skill: new FormControl("0", Validators.required),
      percent: new FormControl(null, Validators.required),
    })

    this.Form_List_Tahghighat_Record = new FormGroup({

      id: new FormControl(),
      title: new FormControl(null, Validators.required),
      tarikh: new FormControl(null, Validators.required),
      nasher: new FormControl(null, Validators.required),
      link: new FormControl(null, Validators.required),
    })


    this.Form_List_Document_Record = new FormGroup({

      id: new FormControl(),
      grpDoc_id: new FormControl("0", Validators.required),
      tlDoc_id: new FormControl("0", Validators.required),
      shomareh: new FormControl(null, Validators.required),
      taminKonandeh: new FormControl(null, Validators.required),
    })



    this.Nav_Service.CheckValidPage(1138).subscribe(
      data => {
        this.ReadData_SarFaslAmozeshi()
      }
      , error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )
  }

  ReadData_Initial_Status: boolean = false
  ReadData_Initial() {
    this.EditRecord = Number(this.route.snapshot.paramMap.get('id'))
    this.Person_Service.GetSingle(this.EditRecord).subscribe(
      data => {
        this.Data_Kari_List = data['person_Kari']
        this.Data_Tahsilat_List = data['person_Tahsili']
        this.Data_Amoozeshi_List = data['person_Amozesh']
        this.Data_Skill_List = data['person_Skill']
        this.Data_Tahghighat_List = data['person_Tahghigh']
        this.Data_Document_List = data['person_Document']


      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }


  //#region آپلود عکس ها

  modalRef_Image: any;
  ModalimageUrl: String = ''
  openModal(template: TemplateRef<any>, imageUrl: String) {
    this.ModalimageUrl = imageUrl
    this.modalRef_Image = this.modalService.show(template);
  }

  //#endregion


  InProccessing: boolean = false

  SubmitEditNewPerson() {

    var Edit_Record_Persone: Person_Interface = Empty_Person_Interface()

    Edit_Record_Persone.id = this.EditRecord


    this.InProccessing = true
    this.Person_Service.EditPersone1(
      Edit_Record_Persone,
      this.Data_Kari_List,
      this.Data_Tahsilat_List,
      this.Data_Amoozeshi_List,
      this.Data_Skill_List,
      this.Data_Tahghighat_List,
      this.Data_Document_List).subscribe(
        data => {
          this.InProccessing = false
          this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")

        }, error => {
          // AuthInterceptor owns authentication; feature errors must preserve credentials.

        }
      )



  }










  //#region   General

  DataList_SarFaslAmozeshi: Array<General_Interface> = []
  ReadData_SarFaslAmozeshi() {
    this.SarFaslAmozeshi_Service.GetActiveList().subscribe(
      data => {
        this.DataList_SarFaslAmozeshi = data
        this.ReadData_Skill()
      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  DataList_DorehAmoozeshi: Array<General_Interface> = []

  ReadData_DorehAmoozeshi() {
    this.DorehAmoozeshi_Service.GetActiveList(Number(this.get_Form_List_Amoozeshi_Record_sarFaslAmozeshi_id().value)).subscribe(
      data => {
        this.DataList_DorehAmoozeshi = data

      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  DataList_Skill: Array<General_Interface> = []

  ReadData_Skill() {
    this.Skill_Service.GetActiveList().subscribe(
      data => {
        console.log(data);

        this.DataList_Skill = data
        this.ReadData_DocumentGroup()
      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  DataList_DocumentGroup: Array<General_Interface> = []
  ReadData_DocumentGroup() {
    this.DocumentGroup_Service.GetActiveList().subscribe(
      data => {
        this.DataList_DocumentGroup = data
        this.ReadData_Initial()
      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  DataList_DocumentTitle: Array<General_Interface> = []
  ReadData_DocumentTitle() {
    this.DocumentTitle_Service.GetActiveList(Number(this.get_Form_List_Document_Record_grpDoc_id().value)).subscribe(
      data => {
        this.DataList_DocumentTitle = data

      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  //#endregion



  //#region تحصیلات
  Form_List_Hasilat_Record: FormGroup
  Data_Tahsilat_List: Array<Person_Tahsili_Interface> = []


  get_Form_List_Hasilat_Record_id() {
    return this.Form_List_Hasilat_Record.get('id') as FormControl;
  }

  get_Form_List_Hasilat_Record_date_starrt() {
    return this.Form_List_Hasilat_Record.get('date_starrt') as FormControl;
  }

  get_Form_List_Hasilat_Record_date_end() {
    return this.Form_List_Hasilat_Record.get('date_end') as FormControl;
  }

  get_Form_List_Hasilat_Record_degree() {
    return this.Form_List_Hasilat_Record.get('degree') as FormControl;
  }

  get_Form_List_Hasilat_Record_reshteh() {
    return this.Form_List_Hasilat_Record.get('reshteh') as FormControl;
  }

  get_Form_List_Hasilat_Record_grayesh() {
    return this.Form_List_Hasilat_Record.get('grayesh') as FormControl;
  }

  get_Form_List_Hasilat_Record_uni() {
    return this.Form_List_Hasilat_Record.get('uni') as FormControl;
  }

  get_Form_List_Hasilat_Record_moadel() {
    return this.Form_List_Hasilat_Record.get('moadel') as FormControl;
  }

  ax_Hasilat_Image: string = ''
  InProccessing_ax_Hasilat_Image: boolean = false
  uploadax_Hasilat_Image(files) {
    if (files.length === 0)
      return;

    const formData = new FormData();


    for (const file of files) {
      formData.append(file.name, file);
    }

    this.InProccessing_ax_Hasilat_Image = true

    this.Person_Service.uploadFile(formData).subscribe(
      data => {
        this.InProccessing_ax_Hasilat_Image = false
        if (data['id'] == 0) {
          this.Alertify_Service.ErrorMessage(data['filename'])
        }
        else {
          this.Alertify_Service.SuccessMessage("فایل آپلود شد")
          this.ax_Hasilat_Image = data['filename']
        }
      }
    )

  }

  Remove_uploadax_Hasilat_Image() {
    this.ax_Hasilat_Image = ''
  }

  onSubmitTahsimla() {
    var temp: Person_Tahsili_Interface = Empty_Person_Tahsili_Interface();
    temp.id = 0
    temp.date_starrt = this.get_Form_List_Hasilat_Record_date_starrt().value
    temp.date_end = this.get_Form_List_Hasilat_Record_date_end().value
    temp.degree = this.get_Form_List_Hasilat_Record_degree().value
    temp.reshteh = this.get_Form_List_Hasilat_Record_reshteh().value
    temp.grayesh = this.get_Form_List_Hasilat_Record_grayesh().value
    temp.uni = this.get_Form_List_Hasilat_Record_uni().value
    temp.moadel = this.get_Form_List_Hasilat_Record_moadel().value + ""
    temp.image = this.ax_Hasilat_Image


    this.ax_Hasilat_Image = ''
    this.Form_List_Hasilat_Record.reset()

    this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")

    this.Data_Tahsilat_List.push(temp)
  }

  RemoveTahsimla(id) {
    this.Data_Tahsilat_List.splice(id, 1)
    this.Alertify_Service.SuccessMessage("حذف شد")
  }

  //#endregion



  //#region کاری
  Form_List_kari_Record: FormGroup
  Data_Kari_List: Array<Person_Kari_Interface> = []


  get_Form_List_kari_Record_id() {
    return this.Form_List_kari_Record.get('id') as FormControl;
  }

  get_Form_List_kari_Record_date_starrt() {
    return this.Form_List_kari_Record.get('date_starrt') as FormControl;
  }

  get_Form_List_kari_Record_date_end() {
    return this.Form_List_kari_Record.get('date_end') as FormControl;
  }

  get_Form_List_kari_Record_companyName() {
    return this.Form_List_kari_Record.get('companyName') as FormControl;
  }

  get_Form_List_kari_Record_type() {
    return this.Form_List_kari_Record.get('type') as FormControl;
  }

  get_Form_List_kari_Record_semat() {
    return this.Form_List_kari_Record.get('semat') as FormControl;
  }

  get_Form_List_kari_Record_leave() {
    return this.Form_List_kari_Record.get('leave') as FormControl;
  }

  get_Form_List_kari_Record_tel() {
    return this.Form_List_kari_Record.get('tel') as FormControl;
  }

  get_Form_List_kari_Record_address() {
    return this.Form_List_kari_Record.get('address') as FormControl;
  }



  onSubmitkari() {
    var temp: Person_Kari_Interface = Empty_Person_Kari_Interface();
    temp.id = 0
    temp.date_starrt = this.get_Form_List_kari_Record_date_starrt().value
    temp.date_end = this.get_Form_List_kari_Record_date_end().value
    temp.companyName = this.get_Form_List_kari_Record_companyName().value
    temp.type = this.get_Form_List_kari_Record_type().value
    temp.semat = this.get_Form_List_kari_Record_semat().value
    temp.leave = this.get_Form_List_kari_Record_leave().value
    temp.tel = this.get_Form_List_kari_Record_tel().value
    temp.address = this.get_Form_List_kari_Record_address().value

    this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")

    this.Data_Kari_List.push(temp)
  }

  RemoveKari(id) {
    this.Data_Kari_List.splice(id, 1)
    this.Alertify_Service.SuccessMessage("حذف شد")
  }

  //#endregion



  //#region آموزشی
  Form_List_Amoozeshi_Record: FormGroup
  Data_Amoozeshi_List: Array<Person_Amozesh_Interface> = []


  get_Form_List_Amoozeshi_Record_id() {
    return this.Form_List_Amoozeshi_Record.get('id') as FormControl;
  }

  get_Form_List_Amoozeshi_Record_date_starrt() {
    return this.Form_List_Amoozeshi_Record.get('date_starrt') as FormControl;
  }

  get_Form_List_Amoozeshi_Record_date_end() {
    return this.Form_List_Amoozeshi_Record.get('date_end') as FormControl;
  }

  get_Form_List_Amoozeshi_Record_sarFaslAmozeshi_id() {
    return this.Form_List_Amoozeshi_Record.get('sarFaslAmozeshi_id') as FormControl;
  }

  get_Form_List_Amoozeshi_Record_dorehAmoozeshi_id() {
    return this.Form_List_Amoozeshi_Record.get('dorehAmoozeshi_id') as FormControl;
  }

  get_Form_List_Amoozeshi_Record_modat() {
    return this.Form_List_Amoozeshi_Record.get('modat') as FormControl;
  }

  get_Form_List_Amoozeshi_Record_bargozarKonnadeh() {
    return this.Form_List_Amoozeshi_Record.get('bargozarKonnadeh') as FormControl;
  }


  ax_Amoozeshi_Image: string = ''
  InProccessing_ax_Amoozeshi_Image: boolean = false
  uploadax_Amoozeshi_Image(files) {
    if (files.length === 0)
      return;

    const formData = new FormData();


    for (const file of files) {
      formData.append(file.name, file);
    }

    this.InProccessing_ax_Amoozeshi_Image = true

    this.Person_Service.uploadFile(formData).subscribe(
      data => {
        this.InProccessing_ax_Amoozeshi_Image = false
        if (data['id'] == 0) {
          this.Alertify_Service.ErrorMessage(data['filename'])
        }
        else {
          this.Alertify_Service.SuccessMessage("فایل آپلود شد")
          this.ax_Amoozeshi_Image = data['filename']
        }
      }
    )

  }

  Remove_uploadax_Amoozeshi_Image() {
    this.ax_Amoozeshi_Image = ''
  }

  onSubmitAmozeshi() {

    if (this.get_Form_List_Amoozeshi_Record_dorehAmoozeshi_id().value == "0") {
      this.Alertify_Service.ErrorMessage("عنوان دوره آموزشی را انتخاب نمائید")
    }
    else if (this.get_Form_List_Amoozeshi_Record_sarFaslAmozeshi_id().value == "0") {
      this.Alertify_Service.ErrorMessage("سرفصل آموزشی را انتخاب نمائید")
    }
    else {
      var temp: Person_Amozesh_Interface = Empty_Person_Amozesh_Interface();
      temp.id = 0
      temp.date_starrt = this.get_Form_List_Amoozeshi_Record_date_starrt().value
      temp.date_end = this.get_Form_List_Amoozeshi_Record_date_end().value
      temp.sarFaslAmozeshi_id = Number(this.get_Form_List_Amoozeshi_Record_sarFaslAmozeshi_id().value)
      temp.sarFaslAmozeshiTitle = this.find_sarFaslAmozeshi(temp.sarFaslAmozeshi_id)

      temp.dorehAmoozeshi_id = Number(this.get_Form_List_Amoozeshi_Record_dorehAmoozeshi_id().value)
      temp.dorehAmoozeshiTitle = this.find_dorehAmoozeshi(temp.dorehAmoozeshi_id)

      temp.modat = Number(this.get_Form_List_Amoozeshi_Record_modat().value)
      temp.bargozarKonnadeh = this.get_Form_List_Amoozeshi_Record_bargozarKonnadeh().value
      temp.image = this.ax_Amoozeshi_Image


      this.ax_Amoozeshi_Image = ''
      this.Form_List_Amoozeshi_Record.reset()
      this.get_Form_List_Amoozeshi_Record_sarFaslAmozeshi_id().setValue("0")
      this.get_Form_List_Amoozeshi_Record_dorehAmoozeshi_id().setValue("0")

      this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")

      this.Data_Amoozeshi_List.push(temp)
    }
  }


  find_sarFaslAmozeshi(id) {
    for (let item of this.DataList_SarFaslAmozeshi) {
      if (item.id == id) {
        return item.title
      }
    }
  }

  find_dorehAmoozeshi(id) {
    for (let item of this.DataList_DorehAmoozeshi) {
      if (item.id == id) {
        return item.title
      }
    }
  }


  RemoveAmozeshi(id) {
    this.Data_Amoozeshi_List.splice(id, 1)
    this.Alertify_Service.SuccessMessage("حذف شد")
  }

  //#endregion


  //#region مهارت
  Form_List_Skill_Record: FormGroup
  Data_Skill_List: Array<Person_Skill_Interface> = []


  get_Form_List_Skill_Record_id() {
    return this.Form_List_Skill_Record.get('id') as FormControl;
  }

  get_Form_List_Skill_Record_skill() {
    return this.Form_List_Skill_Record.get('skill') as FormControl;
  }

  get_Form_List_Skill_Record_percent() {
    return this.Form_List_Skill_Record.get('percent') as FormControl;
  }


  onSubmitSkill() {

    if (this.get_Form_List_Skill_Record_skill().value == "0") {
      this.Alertify_Service.ErrorMessage("مهارت را انتخاب نمائید")
    }
    else if (Number(this.get_Form_List_Skill_Record_percent().value) > 100 || Number(this.get_Form_List_Skill_Record_percent().value) < 0) {
      this.Alertify_Service.ErrorMessage("درصد را صحیح وارد نشده است")
    }
    else {
      var temp: Person_Skill_Interface = Empty_Person_Skill_Interface();
      temp.id = 0
      temp.skill_id = Number(this.get_Form_List_Skill_Record_skill().value)
      temp.skillTitle = this.find_Skill(temp.skill_id)
      temp.percennt = Number(this.get_Form_List_Skill_Record_percent().value)


      this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")

      this.Form_List_Skill_Record.reset()

      this.get_Form_List_Skill_Record_skill().setValue("0")

      this.Data_Skill_List.push(temp)
    }
  }

  find_Skill(id) {
    for (let item of this.DataList_Skill) {
      if (item.id == id) {
        return item.title
      }
    }
  }

  RemoveSkill(id) {
    this.Data_Skill_List.splice(id, 1)
    this.Alertify_Service.SuccessMessage("حذف شد")
  }

  //#endregion



  //#region تحقیقات
  Form_List_Tahghighat_Record: FormGroup
  Data_Tahghighat_List: Array<Person_Tahghigh_Interface> = []


  get_Form_List_Tahghighat_Record_id() {
    return this.Form_List_Tahghighat_Record.get('id') as FormControl;
  }

  get_Form_List_Tahghighat_Record_title() {
    return this.Form_List_Tahghighat_Record.get('title') as FormControl;
  }
  get_Form_List_Tahghighat_Record_tarikh() {
    return this.Form_List_Tahghighat_Record.get('tarikh') as FormControl;
  }
  get_Form_List_Tahghighat_Record_nasher() {
    return this.Form_List_Tahghighat_Record.get('nasher') as FormControl;
  }
  get_Form_List_Tahghighat_Record_link() {
    return this.Form_List_Tahghighat_Record.get('link') as FormControl;
  }


  onSubmitTahghighat() {

    var temp: Person_Tahghigh_Interface = Empty_Person_Tahghigh_Interface();
    temp.id = 0
    temp.title = this.get_Form_List_Tahghighat_Record_title().value
    temp.tarikh = this.get_Form_List_Tahghighat_Record_tarikh().value
    temp.nasher = this.get_Form_List_Tahghighat_Record_nasher().value
    temp.link = this.get_Form_List_Tahghighat_Record_link().value

    this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")

    this.Form_List_Tahghighat_Record.reset()
    this.Data_Tahghighat_List.push(temp)
  }

  RemoveTahghighat(id) {
    this.Data_Tahghighat_List.splice(id, 1)
    this.Alertify_Service.SuccessMessage("حذف شد")
  }

  //#endregion


  //#region مهارت
  Form_List_Document_Record: FormGroup
  Data_Document_List: Array<Person_Document_Interface> = []


  get_Form_List_Document_Record_id() {
    return this.Form_List_Document_Record.get('id') as FormControl;
  }

  get_Form_List_Document_Record_grpDoc_id() {
    return this.Form_List_Document_Record.get('grpDoc_id') as FormControl;
  }
  get_Form_List_Document_Record_tlDoc_id() {
    return this.Form_List_Document_Record.get('tlDoc_id') as FormControl;
  }
  get_Form_List_Document_Record_shomareh() {
    return this.Form_List_Document_Record.get('shomareh') as FormControl;
  }
  get_Form_List_Document_Record_taminKonandeh() {
    return this.Form_List_Document_Record.get('taminKonandeh') as FormControl;
  }




  onSubmitDocument() {

    if (this.get_Form_List_Document_Record_grpDoc_id().value == "0") {
      this.Alertify_Service.ErrorMessage("گروه اسناد را انتخاب نمائید")
    }
    else if (this.get_Form_List_Document_Record_tlDoc_id().value == "0") {
      this.Alertify_Service.ErrorMessage("عنوان سند را انتخاب نمائید")
    }
    else {
      var temp: Person_Document_Interface = Empty_Person_Document_Interface();
      temp.id = 0
      temp.grpDoc_id = Number(this.get_Form_List_Document_Record_grpDoc_id().value)
      temp.grpDocTitle = this.find_DocumentGroup(temp.grpDoc_id)

      temp.tlDoc_id = Number(this.get_Form_List_Document_Record_tlDoc_id().value)
      temp.tlDocTitle = this.find_DocumentTitle(temp.tlDoc_id)


      temp.shomareh = this.get_Form_List_Document_Record_shomareh().value
      temp.taminKonandeh = this.get_Form_List_Document_Record_taminKonandeh().value



      this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")

      this.Form_List_Document_Record.reset()

      this.get_Form_List_Document_Record_grpDoc_id().setValue("0")
      this.get_Form_List_Document_Record_tlDoc_id().setValue("0")

      this.Data_Document_List.push(temp)
    }
  }

  find_DocumentGroup(id) {
    for (let item of this.DataList_DocumentGroup) {
      if (item.id == id) {
        return item.title
      }
    }
  }

  find_DocumentTitle(id) {
    for (let item of this.DataList_DocumentTitle) {
      if (item.id == id) {
        return item.title
      }
    }
  }

  RemoveDocument(id) {
    this.Data_Document_List.splice(id, 1)
    this.Alertify_Service.SuccessMessage("حذف شد")
  }

  //#endregion




}
